<template>
<div class="login-page">
  <img :src="require('@/assets/images/logo-web-white.svg')" class="mb-8 mx-auto" style="margin">
  <div class="form" >
    <form class="login-form" @submit.prevent="login()">
      <input type="text" placeholder="username" v-model="name" :disabled="loggingIn"/>
      <input type="password" placeholder="password" v-model="pw"/>
      <div v-if="formError" class="text-red-400 mb-3">Invalid username or password</div>
      <button class="bg-dark-blue hover:bg-opacity-75" type="submit" :disabled="loggingIn">
          login
          <div v-if="loggingIn" class="loader-button float-right"></div>
      </button>
      <p class="message">Not registered? <a href="https://webaruba.com/user/register" class="text-dark-blue">Create an account</a></p>
    </form>
  </div>
</div>

</template>

<script>
export default {
    data() {
        return {
            name:null,
            pw: null,
            formError: false,
            loggingIn: false
        }
    },
    computed: {

    },
    methods: {
        login() {
            if(this.name == null || this.pw == null) {
                this.formError = true
                return;
            }
            this.formError = false;
            this.loggingIn = true;
            this.$store.dispatch('LOGIN', {name: this.name, pass: this.pw }).then(userData => {
                if(userData) {
                  this.$store.dispatch('GET_USER_ROLE', {token: userData.csrf_token, userId: userData.current_user.uid, name: this.name, pass: this.pw }).then((userRoles)=>{
                      this.loggingIn = false;
                      userData.roles = userRoles;
                      this.$store.commit('SET_USER_OBJECT', userData);
                      localStorage.setItem('userData', JSON.stringify(userData));
                      
                      if(userData.roles.includes('aqi_monitor_web')) {
                        this.$router.push({ name: 'MonitorPageView', params: { company: 'web' } })
                      }
                      else if(userData.roles.includes('aqi_monitor_astec'))  {
                        this.$router.push({ name: 'MonitorPageView', params: { company: 'astec' } })
                      }
                      else {
                        this.$store.commit('LOGOUT');
                        this.formError = true;
                      }

                    })
                } else {
                    this.loggingIn = false;
                    this.formError = true;
                }
            }).catch(() => this.loggingIn = false );
        }
    }

}
</script>

<style lang="scss">

.login-page {
  width: 460px;
  //padding: 8% 0 0;
  margin: auto;
}
.form {
  position: relative;
  z-index: 1;
  background: #FFFFFF;
  max-width: 460px;
  margin: 0 auto 100px;
  padding: 40px 20px;
  text-align: center;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
}
.form input {
  outline: 0;
  background: #f2f2f2;
  width: 100%;
  border: 0;
  margin: 0 0 15px;
  color: grey;
  padding: 15px;
  box-sizing: border-box;
  font-size: 16px;
}
.form button {
  text-transform: uppercase;
  outline: 0;
  width: 100%;
  border: 0;
  padding: 15px;
  color: #FFFFFF;
  font-size: 18px;
  -webkit-transition: all 0.3 ease;
  transition: all 0.3 ease;
  cursor: pointer;
}

.form .message {
  margin: 15px 0 0;
  color: #b3b3b3;
  font-size: 12px;
}
.form .message a {
  text-decoration: none;
}
.form .register-form {
  display: none;
}
.container {
  position: relative;
  z-index: 1;
  max-width: 300px;
  margin: 0 auto;
}
.container:before, .container:after {
  content: "";
  display: block;
  clear: both;
}
.container .info {
  margin: 50px auto;
  text-align: center;
}
.container .info h1 {
  margin: 0 0 15px;
  padding: 0;
  font-size: 36px;
  font-weight: 300;
  color: #1a1a1a;
}
.container .info span {
  color: #4d4d4d;
  font-size: 12px;
}
.container .info span a {
  color: #000000;
  text-decoration: none;
}
.container .info span .fa {
  color: #EF3B3A;
}


.loader-button {
    border: 5px solid #f3f3f3; /* Light grey */
    border-top: 5px solid #3498db; /* Blue */
    border-radius: 50%;
    width: 30px;
    height: 30px;
    animation: spin 1s linear infinite;
}


@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>